// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".container.flex-direction-row[data-v-6cb9b803]{justify-content:space-between}", ""]);
// Exports
module.exports = exports;
